import { useNavigate } from 'react-router-dom';

import { joinFeatureWaitlist } from 'api/HealthcareProgram';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

export const useJoinFeatureWaitlist = ({ onSuccess } = {}) => {
  const navigate = useNavigate();

  return useCustomMutation({
    mutationFn: (params) => joinFeatureWaitlist(navigate, params),
    successMessage: "You're on the waitlist",
    onSuccess
  });
};
